
// import React from 'react';

interface Options {
  scriptId?: string;
  src: string;
}

export const useLoadThirdScript = ({ src, scriptId = ''  }: Options) => {
  const loadThirdPart = (callback?: (scriptId?: string) => void) => {
    const existingScript = document.getElementById(scriptId);

    if (existingScript)  return;

    const script = document.createElement('script');
    script.src = src;
    script.id = scriptId;
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback(scriptId);
    };
  };
  return { loadThirdPart };
};
